/* eslint-disable nonblock-statement-body-position */
import { useState, useEffect, useRef } from "react";
import PageTitle from "../../../../components/PageTitle";
import { Grid } from "@mui/material";
import useStyles from "../../styles";
// import { Numbers } from "../../../../utils/DropDown";
import QuestionText from "../component/QuestionText";
import PageLoader from "../../../../components/PageLoader";
import ProgressBar from "@ramonak/react-progress-bar";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useParams, useNavigate } from "react-router-dom";
import { axiosrequest } from "../../../../data/api";
import Modal from "../../../../components/Modal";
// import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from "react-toastify";
import Button from "../../../../components/Button";
import { questionDisplayIndex } from "../../../../utils/questionDisplayIndex";

const APPLICANT_EXAM = "/api/v1/applicant/exams";
const APPLICANT_CACHE = "/api/v1/applicant/exams";

const Examination = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [applicantExam, setApplicantExam] = useState({});
  const [percentage, setPercentage] = useState(100);
  const [timer, setTimer] = useState("00:00:00");
  const classes = useStyles();
  // const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  // const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const [totalTime, setTotalTime] = useState({});
  const [isExamStarted, setIsExamStarted] = useState(false);
  const applicantExamRef = useRef(applicantExam);
  const [activeQuestion, setActiveQuestion] = useState(null);
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
  const [leaveModal, setLeaveModal] = useState(false);
  // const [timeStamp, setTimeStamp] = useState(0);
  const timeStampRef = useRef(0);
  // eslint-disable-next-line no-unused-vars
  const [selectedAnswer, setSelectedAnswer] = useState({
    answers: []
  });

  const handleCloseLeaveModal = () => {
    setLeaveModal(false);
  };

  const handleLeaveExamModal = () => {
    setLeaveModal(true);
  };

  const handleNext = () => {
    if (applicantExam?.questions && activeQuestionIndex < applicantExam.questions.length - 1) {
      setActiveQuestionIndex(prevIndex => prevIndex + 1);
    }
  };

  const handlePrevious = () => {
    if (activeQuestionIndex > 0) {
      setActiveQuestionIndex(prevIndex => prevIndex - 1);
    }
  };

  useEffect(() => {
    const fetchExam = async () => {
      try {
        setIsLoading(true);
        const data = await axiosrequest.get(`${APPLICANT_EXAM}/${id}`);
        setApplicantExam(data?.data?.data);
        setTotalTime(data?.data?.data?.duration);
        setSelectedAnswer({
          answers: data?.data?.data?.questions.map((question) => ({
            question_index: question.question_index,
            answer: question.answer
          }))
        });
      } catch (err) {
        toast.error(err?.response?.data);
      } finally {
        setIsLoading(false);
      }
    };
    fetchExam();
  }, []);

  const handleNavigate = () => {
    localStorage.removeItem(`examTimestamp_${id}`);
    localStorage.removeItem(`remainingTime_${id}`);
    localStorage.removeItem(`timer_${id}`);
    setIsExamStarted(false);
    setTimeout(() => {
      navigate("/student-application");
    }, 1000);
  };

  // post each answer that's clicked
  const handleAnswerClick = (questionIndex, answer, type) => {
    // Update only the selected question's answer
    const updatedQuestions = applicantExam.questions.map((question) => {
      if (question.question_index === questionIndex) {
        const updatedQuestion = { ...question };

        if (type === "checkbox") {
          // Initialize the answer array if not present
          if (!updatedQuestion.answer) {
            updatedQuestion.answer = [];
          }

          const answerIndex = updatedQuestion.answer.indexOf(answer);
          if (answerIndex !== -1) {
            // Uncheck the answer
            updatedQuestion.answer.splice(answerIndex, 1);
          } else {
            // Check the answer
            updatedQuestion.answer.push(answer);
          }
        } else if (type === "multiple_choice") {
          // Replace the current answer for single-choice questions
          updatedQuestion.answer = [answer];
        }

        return updatedQuestion;
      }

      return question;
    });

    // Create the updated exam object
    const updatedExam = {
      ...applicantExam,
      questions: updatedQuestions
    };

    const updatedSelectedAnswer = updatedQuestions.map((question) => ({
      question_index: question.question_index,
      answer: question.answer
    }));

    // Create the updated exam payload to send to backend
    const payload = {
      ...updatedExam,
      questions: updatedExam.questions.map(q => ({
        ...q,
        type: q.type === "true_false" ? "multiple_choice" : q.type
      }))
    };

    // Send the updated
    axiosrequest
      .patch(`${APPLICANT_CACHE}/${id}/cache`, payload)
      .then(() => {
        // Update the state locally to reflect changes without re-fetching
        setApplicantExam(updatedExam);
        setSelectedAnswer({ answers: updatedSelectedAnswer });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
      });
  };

  const lastAnswered = selectedAnswer?.answers
    .filter(item => item?.answer && item?.answer.length > 0)
    .at(-1); // gets the last item in the filtered list

  const lastQuestionIndex = lastAnswered?.question_index ?? 1;

  // for Submit Exam
  const handleFinalSubmit = async (applicantExam) => {
    try {
      timeStampRef.current = 0;
      const correctedExam = {
        ...applicantExam,
        questions: applicantExam?.questions?.map(q => ({
          ...q,
          type: q.type === "true_false" ? "multiple_choice" : q.type
        }))
      };
      const res = await axiosrequest.patch(`${APPLICANT_EXAM}/${id}`, correctedExam);
      toast.success(res?.data?.message);
      // Navigate after successful response
      localStorage.removeItem(`examTimestamp_${id}`);
      localStorage.removeItem(`remainingTime_${id}`);
      localStorage.removeItem(`timer_${id}`);
      setIsExamStarted(false);
      setTimeout(() => {
        handleNavigate();
      }, 1000);
    } catch (err) {
      setTimeout(() => {
        handleNavigate();
      }, 1000);
      toast.error(err?.response?.data?.message);
    }
  };

  // Navigate to clicked question
  const handleNavigateToQuestion = (index) => {
    setActiveQuestion(index);
    setActiveQuestionIndex(index);
    // const idElement = document.getElementById(`question_${index}`);
    // if (idElement) {
    //   idElement.scrollIntoView({ behavior: "smooth" });
    // }
  };

  const isQuestionAnswered = (questionIndex) => {
    return selectedAnswer?.answers.some(
      (a) => a?.question_index === questionIndex && a?.answer?.length > 0
    ) || false;
  };

  const handleStartExam = () => {
    if (totalTime > 0) {
      setIsExamStarted(true);
      const totalSeconds = totalTime * 60;
      const deadline = Date.now() + totalSeconds * 1000;

      const interval = setInterval(() => {
        const remainingTime = Math.max(0, deadline - Date.now());

        const hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
        const seconds = Math.floor((remainingTime / 1000) % 60);

        setTimer(
          `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`
        );

        const percentageRemaining = Math.round((remainingTime / (totalTime * 60 * 1000)) * 100);
        setPercentage(100 - percentageRemaining);

        // Save remaining time and pause exam on reload
        // if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
        //   timeStampRef.current = remainingTime;
        //   clearInterval(interval);

        //   return;
        // }

        const secondsInCurrentMinute = remainingTime % 60000;

        // Check if secondsInCurrentMinute is within a few seconds of a new minute
        if (secondsInCurrentMinute < 1000) {
          localStorage.setItem(`examTimestamp_${id}`, remainingTime);
          localStorage.setItem(`remainingTime_${id}`, 100 - percentageRemaining);
          localStorage.setItem(`timer_${id}`, `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`);
        }

        if (remainingTime === 0) {
          handleFinalSubmit(applicantExamRef.current);
          clearInterval(interval);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  };

  // Restore exam state after reload
  const handleContinueExam = () => {
    if (totalTime > 0) {
      setIsExamStarted(true);
      setActiveQuestionIndex(lastQuestionIndex - 1);

      // timeStampRef.current = localStorage.getItem("examTimestamp")
      //   ? Number(localStorage.getItem("examTimestamp"))
      //   : totalTime * 60 * 1000;

      const interval = setInterval(() => {
        const remainingTime = Math.max(0, timeStampRef.current - 1000);
        timeStampRef.current = remainingTime;

        const hours = Math.floor((remainingTime / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((remainingTime / (1000 * 60)) % 60);
        const seconds = Math.floor((remainingTime / 1000) % 60);

        setTimer(
          `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`
        );

        const percentageRemaining = Math.round((remainingTime / (totalTime * 60 * 1000)) * 100);
        setPercentage(100 - percentageRemaining);

        const secondsInCurrentMinute = remainingTime % 60000;

        // Check if secondsInCurrentMinute is within a few seconds of a new minute
        if (secondsInCurrentMinute < 1000) {
          localStorage.setItem(`examTimestamp_${id}`, remainingTime);
          localStorage.setItem(`remainingTime_${id}`, 100 - percentageRemaining);
          localStorage.setItem(`timer_${id}`, `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${seconds > 9 ? seconds : `0${seconds}`}`);
        }

        if (remainingTime === 0) {
          handleFinalSubmit(applicantExamRef.current);
          clearInterval(interval);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  };

  useEffect(() => {
    const savedTimestamp = localStorage.getItem(`examTimestamp_${id}`);
    const RemainingTime = localStorage.getItem(`remainingTime_${id}`);
    const Time = localStorage.getItem(`timer_${id}`);

    if (savedTimestamp) {
      timeStampRef.current = parseInt(savedTimestamp);
      setPercentage(RemainingTime);
      setTimer(Time);

      // If the saved timestamp is valid, continue the exam
      setIsExamStarted(false);
    }
  }, []);

  useEffect(() => {
    applicantExamRef.current = applicantExam;
  }, [applicantExam]);

  return (
    <div className={`${classes.overall} page-content`}>
      <PageTitle
        title={applicantExam?.title}
        subtitle={applicantExam?.instruction}
        button={
          <div className="flex gap-10">
            <Button
              variant="dangeroutline"
              buttonSize="fluid"
              color="btndanger"
              buttonName="Leave Exam"
              onClick={handleLeaveExamModal}
            />
            <Button
              variant="primary"
              buttonSize="fluid"
              color="btndefault"
              buttonName="Submit Exam"
              onClick={() => handleFinalSubmit(applicantExamRef.current)}
            />
          </div>
        }
      />
      <div className={`${classes.overall} margin-top-30`}>
        <Grid container spacing={2}>
          <Grid item lg={9} md={9} sm={12} xs={12}>
            <div className={`${classes.progressbar} padding-inline-10`}>
              <ProgressBar completed={100 - percentage} baseBgColor="#F0F2F5" bgColor="#28AE00" labelSize="12px" height="14px" />
              <div className={classes.timeleft}>
                <h2>Time Remaining: {timer}</h2>
              </div>
            </div>
            {/* Fetch temporary draft */}
            <div>
              <div>
                {isLoading ? (
                  <PageLoader />
                ) : (
                  <>
                    {!isExamStarted ? (
                      <>
                        <div className={`${classes.getcont}`}>
                          <p className={classes.getstarted}>Please read the following instructions carefully</p>
                          <div className={classes.instructioncont}>
                            <p>1. Ensure a stable internet connection, a compatible device, and a quiet environment</p>
                            <p>2. Follow all exam rules — no external help, no switching tabs, no unauthorized materials.</p>
                            <p>3. Manage your time and complete all questions before submission.</p>
                            <p>4. Review your answers and wait for confirmation before exiting.</p>
                          </div>
                          <Grid container spacing={1}>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <div className={`${classes.enroldetails} flex gap-10`}>
                                <p className={classes.subtitle}>Subject:</p>
                                <p>{applicantExam?.subject || "--/--"}</p>
                              </div>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <div className={`${classes.enroldetails} flex gap-10`}>
                                <p className={classes.subtitle}>Total Questions:</p>
                                <p>{applicantExam?.questions?.length}</p>
                              </div>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <div className={`${classes.enroldetails} flex gap-10`}>
                                <p className={classes.subtitle}>Marks:</p>
                                <p>{applicantExam?.total_grade || "--/--"}</p>
                              </div>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                              <div className={`${classes.enroldetails} flex gap-10`}>
                                <p className={classes.subtitle}>Total Duration:</p>
                                <p>{applicantExam?.duration || "--/--"} mins</p>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div className={classes.btns}>
                          <div>
                            <Button
                              onClick={handleNavigate}
                              variant="dangeroutline"
                              buttonName="Cancel"
                              buttonSize="large"
                              color="btndanger"
                            />
                          </div>
                          <div>
                            {!isExamStarted && (
                              <div className="margin-bottom">
                                {timeStampRef.current > 0 ? (
                                  <Button
                                    onClick={handleContinueExam}
                                    variant="primary"
                                    buttonName="Continue Exam"
                                    buttonSize="large"
                                    color="btndefault"
                                  />
                                ) : (
                                  <Button
                                    onClick={handleStartExam}
                                    variant="primary"
                                    buttonName="Start Exam"
                                    buttonSize="large"
                                    color="btndefault"
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className={`${classes.questionmaincont} container-y-overflow`}>
                          {applicantExam?.questions && applicantExam?.questions.length > 0 && (
                            <QuestionText
                              id={`question_${activeQuestionIndex + 1}`}
                              key={activeQuestionIndex + 1}
                              arrayIndex={activeQuestionIndex}
                              questions={applicantExam?.questions}
                              item={applicantExam?.questions[activeQuestionIndex]}
                              onAnswerClick={(answer) => handleAnswerClick(
                                applicantExam?.questions[activeQuestionIndex]?.question_index,
                                answer - 1,
                                applicantExam?.questions[activeQuestionIndex]?.type
                              )
                              }
                            />
                          )}
                        </div>
                        <div className={classes.desktopbtns}>
                          <div className={classes.submitbtn}>
                            <Button
                              onClick={handlePrevious}
                              variant="primaryoutline"
                              color="btnfontprimary"
                              buttonName="Previous"
                              buttonSize="medium"
                              disabled={activeQuestionIndex === 0}
                            />
                            {activeQuestionIndex === applicantExam?.questions?.length - 1 ? (
                              <Button
                                variant="primary"
                                buttonSize="medium"
                                color="btndefault"
                                buttonName="Submit Exam"
                                onClick={() => handleFinalSubmit(applicantExamRef.current)}
                              />
                            ) : (
                              <Button
                                onClick={handleNext}
                                variant="primary"
                                color="btndefault"
                                buttonName="Next"
                                buttonSize="medium"
                                disabled={activeQuestionIndex === applicantExam?.questions?.length - 1}
                              />
                            )
                            }
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </Grid>
          <div className={classes.mobilescont}>
            <div className={classes.mobiles}>
              {isExamStarted && (
                <div className={classes.submitbtn}>
                  <Button
                    onClick={handlePrevious}
                    variant="primaryoutline"
                    color="btnfontprimary"
                    buttonName="Previous"
                    buttonSize="medium"
                    disabled={activeQuestionIndex === 0}
                  />

                  {activeQuestionIndex === applicantExam?.questions?.length - 1 ? (
                    <Button
                      variant="primary"
                      buttonSize="medium"
                      color="btndefault"
                      buttonName="Submit Exam"
                      onClick={() => handleFinalSubmit(applicantExamRef.current)}
                    />
                  ) : (
                    <Button
                      onClick={handleNext}
                      variant="primary"
                      color="btndefault"
                      buttonName="Next"
                      buttonSize="medium"
                      disabled={activeQuestionIndex === applicantExam?.questions?.length - 1}
                    />
                  )
                  }
                </div>
              )}
              {isExamStarted && (
                <div className={`${classes.questioncont}`}>
                  <h5>QUESTIONS</h5>
                  <Grid container spacing={1}>
                    {applicantExam && applicantExam?.questions ? (
                      applicantExam?.questions.map((queNumber, index) => (
                        <Grid item key={index} lg={3} md={3} sm={1} xs={2}>
                          <p onClick={() => handleNavigateToQuestion(index)}
                            style={{
                              backgroundColor: isQuestionAnswered(queNumber?.question_index) ? "#d4edda" : (activeQuestion === index ? "#F0F2F5" : "transparent"),
                              fontWeight: activeQuestion === index ? "bold" : "normal"
                            }}
                          >{questionDisplayIndex(queNumber, index, applicantExam?.questions)}
                          </p>
                        </Grid>
                      ))
                    ) : (
                      <p>Please Wait ...</p>
                    )}
                  </Grid>
                  {/* <Button onClick={() => handleFinalSubmit(applicantExamRef.current)} variant="primary" buttonName="Submit Exam" buttonSize="full" color="btndefault" /> */}
                </div>
              )}
            </div>
          </div>
          <Grid item lg={3} md={3} sm={12} xs={12}>
            <div className={`${classes.rightcont}`}>
              {/* {!isExamStarted && (
                <div className="margin-bottom">
                  {timeStampRef.current > 0 ? (
                    <Button
                      onClick={handleContinueExam}
                      variant="primary"
                      buttonName="Continue Exam"
                      buttonSize="full"
                      color="btndefault"
                    />
                  ) : (
                    <Button
                      onClick={handleStartExam}
                      variant="primary"
                      buttonName="Start Exam"
                      buttonSize="full"
                      color="btndefault"
                    />
                  )}
                </div>
              )} */}

              <div className={classes.timercont}>
                <h5>Timer</h5>
                <div className={classes.times}>
                  <CircularProgressbar counterClockwise background value={100 - percentage} text={timer} strokeWidth={5}
                    styles={buildStyles({
                      textColor: "#000000",
                      pathColor: "#28AE00",
                      trailColor: "#FFF",
                      textSize: "20px",
                      strokeLinecap: "butt",
                      textWeight: "400"
                    })}
                  />
                </div>
              </div>
              <div className={classes.stickcont}>
                <div className={`${classes.questioncont}`}>
                  <h5>QUESTIONS</h5>
                  <Grid container spacing={1}>
                    {applicantExam && applicantExam?.questions ? (
                      applicantExam?.questions.map((queNumber, index) => (
                        <Grid item key={index} lg={3} md={3} sm={3} xs={2}>
                          <p onClick={() => handleNavigateToQuestion(index)}
                            style={{
                              backgroundColor: isQuestionAnswered(queNumber?.question_index) ? "#d4edda" : (activeQuestion === index ? "#F0F2F5" : "transparent"),
                              fontWeight: activeQuestion === index ? "bold" : "normal"
                            }}
                          >{questionDisplayIndex(queNumber, index, applicantExam?.questions)}
                          </p>
                        </Grid>
                      ))
                    ) : (
                      <p>Please Wait ...</p>
                    )}
                  </Grid>
                  {/* <Button onClick={() => handleFinalSubmit(applicantExamRef.current)} variant="primary" buttonName="Submit Exam" buttonSize="full" color="btndefault" /> */}
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      {/* Leave Exam Modal */}
      <Modal
        title="Leave Exam"
        subtitle={
          <div>
          Are you sure you want to Leave this Exam?
          </div>
        }
        modalContent={<></>}
        modalFooter={
          <>
            <div className="flex gap-10">
              <Button
                variant="dangeroutline"
                buttonSize="full"
                color="btndanger"
                buttonName="Cancel"
                onClick={handleCloseLeaveModal}
              />
              <Button
                variant="danger"
                buttonName="Leave Exam"
                buttonSize="full"
                color="btndefault"
                onClick={handleNavigate}
              />
            </div>
          </>
        }
        isopen={leaveModal}
        closeModal={handleCloseLeaveModal}
      />
    </div>
  );
};

export default Examination;
